"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // ARCHITECT-CONTAINERS [ ARTICLE ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Article = function Article(_ref) {
  var children = _ref.children,
      heading = _ref.heading,
      description = _ref.description; // 2.1. FUNCTIONS ............................................................
  // 2.1.1. RENDER HEADER

  var renderHeader = (0, _react.useCallback)(function () {
    return _react["default"].createElement(_index.ArticleHeader, null, heading && _react["default"].createElement("h2", null, heading), description && _react["default"].createElement("p", null, description));
  }, [heading, description]); // 2.1.1. END
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................

  return _react["default"].createElement("article", null, renderHeader(), children); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. DEFAULT VALUES .........................................................


Article.defaultProps = {
  heading: '',
  description: ''
}; // 3.1. END ....................................................................
// 3.2. TYPES ..................................................................

Article.propTypes = {
  /**  Contents within this component. */
  children: _propTypes["default"].node,

  /**  Section heading. */
  heading: _propTypes["default"].string,

  /**  Section description. */
  description: _propTypes["default"].string
}; // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Article; // END OF FILE #################################################################

exports["default"] = _default;